import type { SVGProps } from 'react';

export function FillFacebookIcon({
  width = 24,
  height = 24,
  stroke,
  fill,
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12.006C0 9.32733 0 6.64866 0 3.96999C0 1.68618 1.664 0 3.936 0C9.31733 0 14.6987 0 20.08 0C22.3307 0 24 1.68084 24 3.93797C24 9.30599 24 14.6793 24 20.0474C24 22.3045 22.3413 23.9907 20.0853 23.996C14.6933 24.0013 9.296 24.0013 3.904 23.996C1.62667 23.996 0.00533333 22.2992 0.00533333 19.9566C0.00533333 17.3047 0.00533333 14.6527 0.00533333 12.0007L0 12.006ZM16.0427 6.83008C16.0427 6.00834 16.048 5.23462 16.0267 4.4609C16.0267 4.39153 15.8347 4.27947 15.7227 4.27414C15.0133 4.22611 14.2987 4.21011 13.5893 4.17275C11.712 4.06603 10.3253 5.04786 9.91467 6.88878C9.74933 7.62515 9.78133 8.4042 9.744 9.16725C9.72267 9.58346 9.744 10.005 9.744 10.4692H7.01867V13.5534H9.74933V21.0452H13.04V13.5374H15.4507C15.616 12.4969 15.7707 11.5044 15.936 10.4532H13.0667C13.0667 9.58346 13.04 8.75638 13.0773 7.9293C13.0987 7.50775 13.4027 7.19827 13.7867 7.04352C14.0853 6.92079 14.416 6.86743 14.7413 6.84075C15.1573 6.80874 15.5787 6.83008 16.0427 6.83008Z"
        fill={fill}
      />
      <path
        d="M16.0426 6.83052C15.5786 6.83052 15.1572 6.80384 14.7412 6.84119C14.4159 6.86787 14.0852 6.92657 13.7866 7.04396C13.4026 7.1987 13.0986 7.50819 13.0772 7.92973C13.0399 8.75148 13.0666 9.5839 13.0666 10.4537H15.9359C15.7706 11.4995 15.6159 12.4974 15.4506 13.5379H13.0399V21.0456H9.74922V13.5539H7.01855V10.4697H9.74389C9.74389 10.0054 9.72789 9.5839 9.74389 9.16769C9.78122 8.40464 9.74922 7.62558 9.91456 6.88921C10.3252 5.04829 11.7119 4.07181 13.5892 4.17319C14.2986 4.21054 15.0132 4.22655 15.7226 4.27457C15.8292 4.27991 16.0212 4.39197 16.0266 4.46133C16.0479 5.23505 16.0426 6.00877 16.0426 6.83052Z"
        fill={stroke}
      />
    </svg>
  );
}
